import React, { Component } from 'react';
import { defaultSorter, dateSorter } from './Helpers';
import { Table, Popconfirm } from 'antd';

class ServicesTable extends Component {

  state = {
    children: []
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter,
    });
  }

  columns = [{
    title: 'Název',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    defaultSortOrder: 'ascend',
    sorter: (a, b) => defaultSorter(a.name, b.name),
  }, {
    title: 'Hostname',
    dataIndex: 'host',
    key: 'host',
    sorter: (a, b) => defaultSorter(a.host, b.host),
  }, {
    title: 'Port',
    dataIndex: 'port',
    key: 'port',
    sorter: (a, b) => defaultSorter(a.port, b.port),
  }, {
    title: 'Instalováno',
    dataIndex: 'installed',
    key: 'installed',
    sorter: (a, b) => defaultSorter(a.installed - b.installed),
    render: (text, record) => {
      return text ? 'Ano' : 'Ne';
    }
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        onChange={this.handleChange}
        style={{ border: '0px' }} />
    );
  }
}

export default ServicesTable;


// WEBPACK FOOTER //
// ./src/components/ServiceTable.js